(function() {
  'use strict';
  
  class CityFilter {
    constructor(section) {
      this.section = section;
      this.pills = section.querySelectorAll('.city-pill');
      this.cards = section.querySelectorAll('.city-filter__grid .store-card');
      this.grid = section.querySelector('.city-filter__grid');
      this.activeCity = null;
      this.isTransitioning = false;
      this.pillsContainer = section.querySelector('.city-filter__pills-wrapper');
      
      this.init();
    }
    
    init() {
      if (!this.pills.length || 
    !this.section.classList.contains('city-filter-section') ||
    !this.section.querySelector('.city-filter__grid')) {
  return;
}

      
      // Set initial state
      const firstPill = this.pills[0];
      if (firstPill) {
        this.activeCity = firstPill.dataset.cityName;
        this.filterStores(firstPill.dataset.city, true);
      }
      
      // Event listeners
      this.bindEvents();
      
      // Handle resize for mobile grid
      this.handleResize();

      window.addEventListener('resize', this.debounce(() => this.handleResize(), 250));
    }
    
    bindEvents() {
      // Click handler
      this.section.addEventListener('click', (e) => {
        const pill = e.target.closest('.city-pill');
        if (pill && !this.isTransitioning) {
          e.preventDefault();
          this.selectCity(pill);
          // Center pill on mobile after selection
          if (window.innerWidth <= 749) {
            this.centerActivePill(pill);
          }
        }
      });
      
      // Keyboard navigation
      this.section.addEventListener('keydown', (e) => {
        const pill = e.target.closest('.city-pill');
        if (!pill) return;
        
        const pills = Array.from(this.pills);
        const currentIndex = pills.indexOf(pill);
        let targetIndex = -1;
        
        switch(e.key) {
          case 'ArrowLeft':
          case 'ArrowUp':
            e.preventDefault();
            targetIndex = currentIndex > 0 ? currentIndex - 1 : pills.length - 1;
            break;
          case 'ArrowRight':
          case 'ArrowDown':
            e.preventDefault();
            targetIndex = currentIndex < pills.length - 1 ? currentIndex + 1 : 0;
            break;
          case 'Enter':
          case ' ':
            e.preventDefault();
            this.selectCity(pill);
            // Center on mobile for keyboard nav
            if (window.innerWidth <= 749) {
              this.centerActivePill(pill);
            }
            return;
          case 'Home':
            e.preventDefault();
            targetIndex = 0;
            break;
          case 'End':
            e.preventDefault();
            targetIndex = pills.length - 1;
            break;
          default:
            return;
        }
        
        if (targetIndex >= 0) {
          pills[targetIndex].focus();
          // Auto-center on keyboard nav
          if (window.innerWidth <= 749) {
            this.centerActivePill(pills[targetIndex]);
          }
        }
      });
    }
    
    selectCity(pill) {
      const city = pill.dataset.city;
      const cityName = pill.dataset.cityName;
      
      // Skip if already active
      if (this.activeCity === cityName || this.isTransitioning) return;
      
      this.isTransitioning = true;
      const startTime = performance.now();
      
      // Update pill states
      this.pills.forEach(p => {
        const isActive = p === pill;
        p.classList.toggle('city-pill--active', isActive);
        p.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      
      // Animate transition
      requestAnimationFrame(() => {
        this.filterStores(city, false, () => {
          this.isTransitioning = false;
          this.handleResize(); // Update grid after filter
          const endTime = performance.now();
          console.debug(`Filter transition: ${Math.round(endTime - startTime)}ms`);
        });
      });
      
      this.activeCity = cityName;
      this.announceChange(cityName, pill.dataset.storeCount);
    }
    
    centerActivePill(pill) {
      if (!this.pillsContainer || !pill) return;
      
      const container = this.pillsContainer;
      const containerWidth = container.offsetWidth;
      const scrollLeft = container.scrollLeft;
      const pillRect = pill.getBoundingClientRect();
      const containerRect = container.getBoundingClientRect();
      
      // Calculate pill position relative to container
      const pillLeft = pill.offsetLeft;
      const pillWidth = pill.offsetWidth;
      const pillCenter = pillLeft + (pillWidth / 2);
      
      // Calculate target scroll position to center the pill
      const targetScroll = pillCenter - (containerWidth / 2);
      
      // Get bounds
      const maxScroll = container.scrollWidth - containerWidth;
      
      // Check if this is first or last pill
      const pills = Array.from(this.pills);
      const pillIndex = pills.indexOf(pill);
      const isFirst = pillIndex === 0;
      const isLast = pillIndex === pills.length - 1;
      
      // For first/last pills, adjust positioning
      let finalScroll = targetScroll;
      
      if (isFirst) {
        // Scroll to start
        finalScroll = 0;
      } else if (isLast) {
        // Scroll to end
        finalScroll = maxScroll;
      } else {
        // Clamp to valid range for middle pills
        finalScroll = Math.max(0, Math.min(targetScroll, maxScroll));
      }
      
      // Smooth scroll to position
      container.scrollTo({
        left: finalScroll,
        behavior: 'smooth'
      });
    }
    
    filterStores(city, immediate = false, callback = null) {
      const visibleCards = [];
      const hiddenCards = [];
      
      // Categorize cards
      this.cards.forEach(card => {
        if (card.dataset.city === city) {
          visibleCards.push(card);
        } else {
          hiddenCards.push(card);
        }
      });
      
      // Hide non-matching cards
      hiddenCards.forEach(card => {
        card.dataset.hidden = 'true';
        card.setAttribute('aria-hidden', 'true');
      });
      
      if (immediate) {
        // Show cards immediately on init
        visibleCards.forEach((card, index) => {
          card.dataset.hidden = 'false';
          card.setAttribute('aria-hidden', 'false');
          card.style.setProperty('--animation-order', index);
        });
        this.handleMobileOddCards(visibleCards);
        if (callback) callback();
      } else {
        // Animate cards in
        visibleCards.forEach(card => {
          card.style.animation = 'none';
          card.offsetHeight; // Force reflow
        });
        
        requestAnimationFrame(() => {
          visibleCards.forEach((card, index) => {
            card.dataset.hidden = 'false';
            card.setAttribute('aria-hidden', 'false');
            card.style.setProperty('--animation-order', index);
            card.style.animation = '';
          });
          
          this.handleMobileOddCards(visibleCards);
          
          // Callback after animations complete
          if (callback) {
            setTimeout(callback, 500 + (visibleCards.length * 60));
          }
        });
      }
    }
    
    handleMobileOddCards(visibleCards) {
      if (!visibleCards.length || !this.section.contains(visibleCards[0])) return;
      // Only apply on mobile
      if (window.innerWidth > 749) {
        visibleCards.forEach(card => {
          card.style.flex = '';
          card.style.maxWidth = '';
        });
        return;
      }
      
      const count = visibleCards.length;
      
      // Reset all cards first
      visibleCards.forEach(card => {
        card.style.flex = '';
        card.style.maxWidth = '';
      });
      
      // If odd number of cards, center the last odd-positioned card
      if (count % 2 === 1) {
        // Find all odd-positioned cards that would be alone in their row
        visibleCards.forEach((card, index) => {
          // Check if this card would be alone in its row (odd position and last, or odd total and last)
          const isLastOddCard = (index === count - 1) && (index % 2 === 0);
          
          if (isLastOddCard) {
            // Center this card
            card.style.flex = '0 0 calc(50% - 8px)';
            card.style.maxWidth = 'calc(50% - 8px)';
          }
        });
      }
    }
    
    handleResize() {
      const visibleCards = Array.from(
  this.section.querySelectorAll('.city-filter__grid .store-card[data-hidden="false"]')
);
if (!visibleCards.length) return;

      this.handleMobileOddCards(visibleCards);
    }
    
    debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }
    
    announceChange(city, count) {
      let announcer = this.section.querySelector('.sr-announcer');
      if (!announcer) {
        announcer = document.createElement('div');
        announcer.className = 'sr-announcer';
        announcer.setAttribute('role', 'status');
        announcer.setAttribute('aria-live', 'polite');
        announcer.setAttribute('aria-atomic', 'true');
        announcer.style.cssText = `
          position: absolute;
          left: -10000px;
          width: 1px;
          height: 1px;
          overflow: hidden;
        `;
        this.section.appendChild(announcer);
      }
      
      const plural = count !== '1' ? 's' : '';
      announcer.textContent = `Now showing ${count} store${plural} in ${city}`;
    }
  }
  
  // Initialize
  function init() {
    document.querySelectorAll('.city-filter-section').forEach(section => {
      if (!section.querySelector('.city-filter__pills') || 
    !section.querySelector('.city-filter__grid')) {
  return;
}

      
      if (!section.querySelector('.city-filter__pills')) return;
      if (!section.cityFilter) {
        section.cityFilter = new CityFilter(section);
      }
    });
  }
  
  // DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // Shopify theme editor support
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => {
      const section = e.target.querySelector('.city-filter-section');
      if (section) {
        // Clean up existing instance
        if (section.cityFilter && section.cityFilter.cleanup) {
          section.cityFilter.cleanup();
        }
        section.cityFilter = new CityFilter(section);
      }
    });
    
    document.addEventListener('shopify:section:unload', (e) => {
      const section = e.target.querySelector('.city-filter-section');
      if (section && section.cityFilter && section.cityFilter.cleanup) {
        section.cityFilter.cleanup();
        delete section.cityFilter;
      }
    });
    
    document.addEventListener('shopify:section:reorder', () => {
      setTimeout(init, 100);
    });
  }
})();